import React from "react";
import { useTranslation } from "react-i18next";
import useTour from "../../hooks/useTour";

const TourProgress = () => {
  const { t } = useTranslation();
  const {
    isActive,
    currentSection,
    sectionCount,
    sections,
    completedSections,
    singleSectionMode,
    goToSection,
  } = useTour();

  if (!isActive || singleSectionMode) return null;

  return (
    <div className="tour-progress">
      <div className="tour-progress__bar">
        {sections.map((section, i) => {
          const isCurrent = i === currentSection;
          const isDone = completedSections.includes(i);
          const cls = [
            "tour-progress__segment",
            isCurrent ? "tour-progress__segment--current" : "",
            isDone ? "tour-progress__segment--done" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              key={section.id}
              type="button"
              className={cls}
              title={t(section.tKey)}
              aria-label={t(section.tKey)}
              onClick={() => goToSection(i)}
            >
              <span className="tour-progress__label">{i + 1}</span>
            </button>
          );
        })}
      </div>
      <span className="tour-progress__text">
        {currentSection + 1}/{sectionCount}
      </span>
    </div>
  );
};

export default TourProgress;
